import { css } from 'styled-components';
import { IAppBarPropsWithTheme } from './AppBar.models';

export const StyledAppBar = ({ theme }: IAppBarPropsWithTheme) => {
  return css`
    > .top {
      display: flex;
      background-color: ${theme.colors.white};
      position: fixed;
      top: 0;
      width: 100%;
      color: ${theme.colors.primaryBackground};
      box-shadow: 0px 4px 4px -2px rgba(24, 39, 75, 0.08);

      height: 88px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.85);
      z-index: 4;

      @media ${theme.device.max.tabletS} {
        height: 60px;
        border: none;
        justify-content: space-between;
      }
    }

    > .bottom {
      color: ${theme.colors.primaryBackground};
      position: fixed;
      top: 60px;
      height: 40px;
      z-index: 3;
      width: 100%;
      overflow: scroll;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      box-shadow: 0px 4px 4px -2px rgba(24, 39, 75, 0.08);

      /* Hide scrollbar for Chrome, Safari and Opera */
      &::-webkit-scrollbar {
        display: none;
      }

      @media ${theme.device.tabletS} {
        display: none;
      }
    }

    > .gap {
      height: 80px;
      display: block;

      @media ${theme.device.max.tabletS} {
        height: 100px;
      }
    }
  `;
};
